import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { AppPopupConfigResponse } from '@/features/appStatus/types/appStatus';

export async function fetchAppPopupConfig() {
  const { data } = await httpClient.get<AppPopupConfigResponse>(
    endpoints.appStatus.popupConfig,
  );
  return data;
}
